import * as React from 'react';
import { CoreCheckbox } from '../internal/WixUiCoreComponents/components/CoreCheckbox';
import { st, classes } from './IconToggle.st.css';
import { deprecationLog } from '../../common/deprecationLog';
import { IconToggleLabelPlacement } from './types';
/**
 * A toggle button represented by an icon and label
 */
export class IconToggle extends React.Component {
    constructor() {
        super(...arguments);
        this._getContent = () => {
            const { checkedIcon, checked, icon, label } = this.props;
            return (React.createElement("div", { className: classes.content },
                React.createElement("div", { "data-icon": true, className: classes.icon }, checkedIcon && checked ? checkedIcon : icon),
                label ? React.createElement("div", { className: classes.spacer }) : null,
                label ? (React.createElement("div", { "data-label": true, className: classes.label }, label)) : null));
        };
    }
    componentDidMount() {
        if (this.props.icon && !this.props.checkedIcon) {
            deprecationLog('IconToggle', 'The current API of this component is deprecated and will be removed in a future version, please use both "checkedIcon" and "icon" props.');
        }
    }
    render() {
        const { label, labelPlacement, onChange, checked, disabled, animation, className, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, } = this.props;
        const content = this._getContent();
        return (React.createElement("span", { "data-label-placement": labelPlacement, className: st(classes.root, { checked, disabled, labelPlacement, animation }, className), "data-hook": this.props['data-hook'] },
            React.createElement(CoreCheckbox, { uncheckedIcon: content, checkedIcon: content, indeterminateIcon: content, error: false, indeterminate: false, checked: checked, disabled: disabled, onChange: onChange, "aria-label": ariaLabel || (typeof label === 'string' ? label : undefined), "aria-labelledby": ariaLabelledBy })));
    }
}
IconToggle.displayName = 'IconToggle';
IconToggle.defaultProps = {
    label: '',
    labelPlacement: IconToggleLabelPlacement.END,
    checked: false,
    disabled: false,
    animation: false,
};
//# sourceMappingURL=IconToggle.js.map